/* ==========================================================================
   Synterra Labs — Product page interactions
   - Gallery (thumb → main sync)
   - Quantity +/-
   - Variant selector → update price, ATC, hidden id
   - Purchase option radio cards (visual select + selling_plan hidden field)
   - Tabs switch (description/specs)
   - Science accordion open/close (animated max-height)
   ========================================================================== */
(function () {
  'use strict';
  if (window.__synterraProductReady) return;
  window.__synterraProductReady = true;

  function $(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '').replace('.', ',');
    return '' + v;
  }

  /* -------- Gallery -------- */
  function initGallery() {
    $$('[data-section-id] [data-synterra-gallery-thumbs]').forEach(function (thumbsWrap) {
      var section = thumbsWrap.closest('[data-section-id]');
      var mainWrap = section.querySelector('[data-synterra-gallery-main]');
      if (!mainWrap) return;

      thumbsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-synterra-gallery-thumb]');
        if (!btn) return;
        var idx = parseInt(btn.dataset.index, 10);
        $$('[data-synterra-gallery-thumb]', thumbsWrap).forEach(function (b) {
          b.classList.toggle('is-active', parseInt(b.dataset.index, 10) === idx);
        });
        $$('[data-synterra-gallery-slide]', mainWrap).forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.dataset.index, 10) === idx);
        });
      });
    });

    /* Thumbs slider arrows (prev/next) */
    $$('[data-synterra-gallery-thumbs-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-synterra-gallery-thumbs]');
      var prev  = slider.querySelector('[data-synterra-gallery-thumbs-prev]');
      var next  = slider.querySelector('[data-synterra-gallery-thumbs-next]');
      if (!track || !prev || !next) return;

      function step() {
        var first = track.querySelector(':scope > *');
        if (!first) return track.clientWidth * 0.85;
        var cs = window.getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function updateDisabled() {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left:  step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateDisabled, { passive: true });
      window.addEventListener('resize', updateDisabled);
      updateDisabled();
    });
  }

  /* -------- Quantity -------- */
  function initQuantity() {
    $$('[data-synterra-qty]').forEach(function (qty) {
      var input = qty.querySelector('[data-synterra-qty-input]');
      if (!input) return;
      qty.addEventListener('click', function (e) {
        var cur = parseInt(input.value, 10) || 1;
        if (e.target.closest('[data-synterra-qty-up]'))   input.value = cur + 1;
        if (e.target.closest('[data-synterra-qty-down]')) input.value = Math.max(1, cur - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* -------- Variant selector -------- */
  function initVariants() {
    $$('[data-section-id]').forEach(function (section) {
      var form = section.querySelector('[data-synterra-product-form]');
      if (!form) return;
      var json = section.querySelector('[data-synterra-product-json]');
      if (!json) return;
      var variants;
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }

      var selects = $$('[data-synterra-variant-option]', form);
      var hiddenId = form.querySelector('[data-synterra-variant-id]');
      var priceNow = form.querySelector('[data-synterra-price]');
      var priceWas = form.querySelector('[data-synterra-price-compare]');
      var atc = form.querySelector('[data-synterra-atc]');
      var atcText = form.querySelector('[data-synterra-atc-text]');
      var stockEl = section.querySelector('[data-synterra-stock]');

      function findVariant() {
        var values = selects.map(function (s) { return s.value; });
        return variants.find(function (v) {
          return values.every(function (val, i) { return v.options[i] === val; });
        });
      }

      function updateUI() {
        var v = findVariant();
        if (!v) return;
        if (hiddenId) hiddenId.value = v.id;
        if (priceNow) priceNow.textContent = formatMoney(v.price);
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceWas.textContent = formatMoney(v.compare_at_price);
            priceWas.style.display = '';
          } else {
            priceWas.style.display = 'none';
          }
        }
        if (atc) {
          atc.disabled = !v.available;
          if (atcText) atcText.textContent = v.available ? (atc.dataset.labelAvail || atcText.textContent) : 'Niet beschikbaar';
        }
        if (stockEl) {
          stockEl.innerHTML = v.available
            ? '<span class="is-available">●</span> Op voorraad'
            : '<span class="is-soldout">●</span> Niet op voorraad';
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', updateUI); });
    });
  }

  /* -------- Purchase options -------- */
  function initPurchaseOptions() {
    $$('[data-synterra-product-form]').forEach(function (form) {
      var options = $$('[data-synterra-purchase-option]', form);
      var sellingPlanInput = form.querySelector('[data-synterra-selling-plan]');
      var qtyInput = form.querySelector('[data-synterra-qty-input]');
      if (options.length === 0) return;

      function syncSelection(opt) {
        options.forEach(function (o) {
          o.classList.remove('is-selected');
          var r = o.querySelector('input[type="radio"]');
          if (r) r.checked = false;
        });
        opt.classList.add('is-selected');
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        // Selling plan sync
        if (sellingPlanInput) {
          sellingPlanInput.value = radio ? (radio.dataset.sellingPlan || '') : '';
        }

        // Qty sync: hidden quantity = option's qty (bundle size)
        var optQty = parseInt(opt.dataset.optionQty, 10) || 1;
        if (qtyInput) qtyInput.value = optQty;
      }

      // On initial load, sync qty input with default-selected option
      var initial = options.filter ? options.filter(function (o) { return o.classList.contains('is-selected'); })[0]
                                   : Array.prototype.filter.call(options, function (o) { return o.classList.contains('is-selected'); })[0];
      if (initial && qtyInput) {
        qtyInput.value = parseInt(initial.dataset.optionQty, 10) || 1;
      }

      options.forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          if (e.target.tagName === 'A') return;
          syncSelection(opt);
        });
      });
    });
  }

  /* -------- Tabs -------- */
  function initTabs() {
    $$('[data-synterra-tabs]').forEach(function (tabs) {
      var section = tabs.parentElement;
      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-synterra-tab]');
        if (!btn) return;
        var name = btn.dataset.syntera_tab || btn.dataset.synterraTab;
        $$('[data-synterra-tab]', tabs).forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        $$('[data-synterra-tab-panel]', section).forEach(function (p) {
          var active = p.dataset.synterraTabPanel === name;
          p.classList.toggle('is-active', active);
          if (active) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      });
    });
  }

  /* -------- Generic scroll-in observer (ingredient bars + timeline) -------- */
  function observeReveal(selector, opts) {
    var els = $$(selector);
    if (els.length === 0) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.setAttribute('data-observed', 'true'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-observed', 'true');
          io.unobserve(entry.target);
        }
      });
    }, opts || { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  /* "Hoe Synterra anders is" — mobile slider arrow navigation */
  function initHowDifferentSlider() {
    var navs = $$('[data-synterra-shd-nav]');
    if (navs.length === 0) return;

    navs.forEach(function (nav) {
      var section = nav.closest('.synterra-how-different');
      if (!section) return;
      var slider = section.querySelector('.synterra-how-different__cards');
      var prev = nav.querySelector('[data-synterra-shd-prev]');
      var next = nav.querySelector('[data-synterra-shd-next]');
      if (!slider) return;

      function cardStep() {
        var first = slider.querySelector('.synterra-how-different__card');
        if (!first) return slider.clientWidth;
        var style = getComputedStyle(slider);
        var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function updateButtonState() {
        if (!prev || !next) return;
        var max = slider.scrollWidth - slider.clientWidth;
        var atStart = slider.scrollLeft <= 2;
        var atEnd   = slider.scrollLeft >= max - 2;
        prev.toggleAttribute('aria-disabled', atStart);
        next.toggleAttribute('aria-disabled', atEnd);
      }

      if (prev) prev.addEventListener('click', function () {
        slider.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        slider.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateButtonState, { passive: true });
      window.addEventListener('resize', updateButtonState);
      updateButtonState();
    });
  }

  function initIngredientBars() {
    observeReveal('[data-synterra-ingredient]', { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });
  }
  /* -------- Timeline scroll-progress fill -------- */
  function initTimelineScrollFill() {
    var list = document.querySelector('.synterra-timeline__list');
    if (!list) return;
    var items = $$('.synterra-timeline__item', list);
    if (items.length === 0) return;

    function update() {
      var rect = list.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var triggerY = vh * 0.5; // de "scroll-lijn" zit op het midden van de viewport

      // Hoeveel pixels van de list zitten boven de trigger lijn
      var progressPx = triggerY - rect.top;
      progressPx = Math.max(0, Math.min(rect.height, progressPx));
      list.style.setProperty('--stl-progress', progressPx + 'px');

      // Mark dot als de centerY van die dot/item-top boven de triggerY zit
      items.forEach(function (item) {
        var itemRect = item.getBoundingClientRect();
        if (itemRect.top + 14 <= triggerY) {
          if (item.getAttribute('data-passed') !== 'true') {
            item.setAttribute('data-passed', 'true');
          }
        } else {
          if (item.getAttribute('data-passed') === 'true') {
            item.removeAttribute('data-passed');
          }
        }
      });
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* (initTimelineReveal verwijderd — alleen scroll-progress fill blijft over) */

  /* -------- Science accordion -------- */
  function initScience() {
    $$('[data-synterra-science-item]').forEach(function (item) {
      var trigger = item.querySelector('[data-synterra-science-trigger]');
      var panel = item.querySelector('[data-synterra-science-panel]');
      if (!trigger || !panel) return;

      // Initial state — if open by default
      if (item.getAttribute('data-open') === 'true') {
        requestAnimationFrame(function () {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      }

      trigger.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', isOpen ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
      });
    });
  }

  /* -------- Boot -------- */
  function boot() {
    initGallery();
    initQuantity();
    initVariants();
    initPurchaseOptions();
    initTabs();
    initScience();
    initIngredientBars();
    initTimelineScrollFill();
    initHowDifferentSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify editor reload
  document.addEventListener('shopify:section:load', boot);
})();
